import { render, staticRenderFns } from "./SurveyClient.vue?vue&type=template&id=b0bb1808&scoped=true&"
import script from "./SurveyClient.vue?vue&type=script&lang=js&"
export * from "./SurveyClient.vue?vue&type=script&lang=js&"
import style0 from "./SurveyClient.vue?vue&type=style&index=0&id=b0bb1808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bb1808",
  null
  
)

export default component.exports